import { Component, computed, EventEmitter, Output } from '@angular/core';
import { updatedAtSignal } from '../analysis-data';
import { v3ComponentContext } from '../services/v3-component-context';
import { findV3AnalysisSignal } from '../services/v3-guest-mode';
import { V3OverviewCardHeader } from '../v3-overview-card-header/v3-overview-card-header';

// V3's main-page "News" card — restyles V2's NewsOverview, layout borrowed from
// V3ScoresOverview (see its CLAUDE.md).
@Component({
  selector: 'app-v3-news-overview',
  imports: [V3OverviewCardHeader],
  standalone: true,
  templateUrl: './v3-news-overview.html',
  styleUrl: './v3-news-overview.scss',
})
export class V3NewsOverview {
  private readonly ctx = v3ComponentContext();

  @Output() navigate = new EventEmitter<void>();

  readonly isZeroDesktop = this.ctx.layout.isZeroDesktop;
  readonly isFinnetDesktop = this.ctx.layout.isFinnetDesktop;
  readonly isFinnet = this.ctx.layout.isFinnet;
  readonly isDesktop = this.ctx.layout.isDesktop;

  // Self-injected rather than an @Input() — V3 overview components read their own data
  // (V3ScoresOverview, V3CompanyProfile).
  private readonly newsAnalysis = findV3AnalysisSignal(
    this.ctx.assetsStore.v2Data,
    'news',
    this.ctx.isGuestMode,
  );

  readonly visible = computed(() => !!this.newsAnalysis());

  readonly title = computed(() => this.newsAnalysis()?.insights?.['highlight']?.['title'] ?? '');
  readonly description = computed(
    () => this.newsAnalysis()?.insights?.['highlight']?.['body'] ?? '',
  );

  readonly updatedAt = updatedAtSignal(this.newsAnalysis);

  onNavigate() {
    this.navigate.emit();
  }
}
